import { HighlightsBar } from './highlightsBar'

export { HighlightsBar }
